var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurnFat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2574808_activity_fitness_health_heart_love_icon 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 288950"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 760",
    d: "M22.2934 18.1926C22.2934 21.2227 20.5543 27.2434 13.5983 27.0853",
    stroke: "#08A693",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 759",
    d: "M11.6341 18.0069C11.7922 7.41467 15.6523 2.92221 17.5626 2C17.4214 2.40019 17.3193 2.79659 17.2495 3.18448C16.655 6.49129 19.414 9.11483 21.5803 11.683C25.6025 16.4512 25.9442 20.6054 25.4672 22.3544C24.5927 27.2128 20.9361 29.1847 17.2688 29.7841C13.1999 30.4491 8.78914 28.6634 7.04318 24.9284C4.56661 19.6305 7.01353 13.7449 9.06513 10.8927C8.43276 15.7936 10.5143 17.6775 11.6341 18.0069Z",
    stroke: "#08A693",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurnFat);
export default __webpack_public_path__ + "static/media/burnFat.1f5e43292d47901ce64dc252e65c0f88.svg";
export { ForwardRef as ReactComponent };